import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { getToolbarComponents } from './toolbar-configuration';
export var primaryToolbarPluginKey = new PluginKey('primaryToolbar');
export var createPlugin = function createPlugin(_ref) {
  var componentRegistry = _ref.componentRegistry,
    contextualFormattingEnabled = _ref.contextualFormattingEnabled;
  return new SafePlugin({
    key: primaryToolbarPluginKey,
    state: {
      init: function init(_config, editorState) {
        return {
          components: getToolbarComponents({
            componentRegistry: componentRegistry,
            editorState: editorState,
            contextualFormattingEnabled: contextualFormattingEnabled
          })
        };
      },
      apply: function apply(_tr, pluginState) {
        return pluginState;
      }
    }
  });
};